import React from "react";
import { Link } from "react-router-dom";
import DisclaimerBanner from "../components/DisclaimerBanner";
import SiteFooter from "../components/SiteFooter";
import ProseLogo from "../components/ProseLogo";
import { Mail, Building2, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <DisclaimerBanner />
      <nav className="border-b border-slate-200 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="contact-logo">
            <ProseLogo size={40} />
          </Link>
          <Link to="/" className="text-xs font-mono-tech uppercase tracking-wider text-slate-600 hover:text-slate-900">
            ← Back to home
          </Link>
        </div>
      </nav>

      <main className="max-w-[820px] mx-auto px-6 py-16 md:py-24" data-testid="contact-page">
        <div className="label-tiny mb-4">Contact</div>
        <h1 className="font-serif-display font-light text-4xl md:text-6xl leading-[1.02] tracking-tight">
          Get in <em className="not-italic font-semibold">touch</em>.
        </h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
          ProSe.Claims is a MisherTech Research &amp; Development initiative. We&apos;re not a law firm and we can&apos;t
          give legal advice, but we do want to hear about your experience, bugs you find, or research questions you want
          us to investigate.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-0">
          <ContactCard
            icon={<Mail className="w-5 h-5 text-slate-700" />}
            label="Email the research team"
            body={<a href="mailto:corporate@mishertech.com" className="underline underline-offset-4 hover:text-slate-900">corporate@mishertech.com</a>}
          />
          <ContactCard
            icon={<Building2 className="w-5 h-5 text-slate-700" />}
            label="Platform owner"
            body="MisherTech — Technology and infrastructure provider"
          />
          <ContactCard
            icon={<MapPin className="w-5 h-5 text-slate-700" />}
            label="Jurisdiction"
            body="United States (Federal + State civil complaint drafting)"
          />
          <ContactCard
            icon={<Mail className="w-5 h-5 text-slate-700" />}
            label="Press &amp; research inquiries"
            body={<a href="mailto:corporate@mishertech.com" className="underline underline-offset-4 hover:text-slate-900">corporate@mishertech.com</a>}
          />
        </div>

        <div className="mt-14 border border-slate-200 p-6 bg-slate-50" data-testid="contact-disclaimer">
          <div className="label-tiny mb-2">Important</div>
          <p className="text-sm text-slate-700 leading-relaxed">
            Do not send confidential legal materials to this address. ProSe.Claims is a technology platform. It is not a
            law firm and does not create an attorney-client relationship. For legal advice, please consult a licensed
            attorney in your jurisdiction.
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

function ContactCard({ icon, label, body }) {
  return (
    <div className="border border-slate-200 -mt-px -ml-px p-6 md:p-8 bg-white">
      <div className="flex items-center gap-2 mb-3">{icon}<div className="label-tiny">{label}</div></div>
      <div className="text-slate-900 text-base leading-relaxed">{body}</div>
    </div>
  );
}
